export const paths = {
  /**
   * Career
   */
  career: {
    root: '/career',
    jobs: '/career/jobs',
    job: '/career/jobs/details',
    posts: '/career/posts',
    post: '/career/posts/details',
    about: '/career/about',
    contact: '/career/contact',
  },
  /**
   * Auth
   */
  split: {
    signIn: '/split/sign-in',
    signUp: '/split/sign-up',
  },
  centered: {
    signIn: '/centered/sign-in',
    signUp: '/centered/sign-up',
  },
  illustration: {
    signIn: '/illustration/sign-in',
    signUp: '/illustration/sign-up',
  },
  verify: '/verify',
  resetPassword: '/reset-password',
  updatePassword: '/update-password',
  /**
   * Common
   */
  maintenance: '/maintenance',
  comingsoon: '/coming-soon',
  pricingCards: '/pricing-cards',
  pricingColumns: '/pricing-columns',
  payment: '/payment',
  support: '/support',
  page404: '/error/404',
  page500: '/error/500',

  /**
   * Global routes (added)
   */
  forBusiness: '/business',
  partners: '/partners',
  about: '/about',
  contactUs: '/contact',
  privacyPolicy: '/privacy-policy',
  termsAndConditions: '/terms-and-conditions',
  faqs: '/faqs',
  careers: '/careers',
  driverPrivacyPolicy: '/privacy-policy/driver',
  driverTermsAndConditions: '/terms-and-conditions/driver',

  /**
   * Others
   */
  components: '/components',
  pages: '/pages',
  docs: 'https://zone-docs.vercel.app',
  license: 'https://material-ui.com/store/license/#i-standard-license',
  minimalStore: 'https://material-ui.com/store/items/minimal-dashboard',
  zoneStore: 'https://mui.com/store/items/zone-landing-page/',
  figmaUrl: 'https://www.figma.com/design/i0ssoAvNd4QmsdhgUTDAKC/-Preview--Zone-Web.v4.2.0',
};
